module.exports = __webpack_public_path__ + "static/media/policies.6f53225f.svg";